import { RequestService } from '../../../../../common/services/RequestService';
import { GET_COUNTS } from '../constants';

export const getCountsRequest = async profileId => {
  const response = await RequestService.get(GET_COUNTS + '?profile_id=' + profileId);
  return response.data
};
